import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal/Modal';
import { formatDate } from '../../../core/helpers';
import { ReactComponent as DownloadIcon } from '../../../icons/download.svg';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  name?: string;
}

export default function CountryDetailsPaymentConfirmationModal({
  isModalOpened,
  closeModal,
  name,
}: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpened={isModalOpened}
      close={closeModal}
      title={t('Payment confirmation')}
      name={name}
    >
      <div className='mx-3 pt-3 pb-4 px-3 text-center'>
        <div className='fw-800 Text--20 mb-3'>
          {formatDate(new Date(2021, 11, 1), 'MMM yyyy')}
        </div>
        <Button
          className='FilingArchiveTab__downloadbtn mb-2'
          styling='outline'
        >
          <DownloadIcon /> Download PDF
        </Button>
      </div>
    </Modal>
  );
}
